/* src/app/front-layout/blogs/blogs.component.css */
.blog-body {
  max-width: 90%;
}
.blog-hero-banner {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background:
    linear-gradient(
      135deg,
      #007BA7 0%,
      #005f87 100%);
  border-radius: 24px;
  overflow: hidden;
  margin: 120px auto 60px;
  max-width: 1400px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}
.blog-hero-banner:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.18);
}
.hero-content {
  padding: 80px 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  animation: fadeInLeft 0.6s ease-out;
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.hero-subtitle {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 2.5px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 16px;
  text-transform: uppercase;
}
.hero-title {
  font-size: 48px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 20px;
  color: white;
  letter-spacing: -0.5px;
}
.hero-description {
  font-size: 16px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.92);
  margin-bottom: 36px;
  max-width: 540px;
}
.hero-btn {
  background:
    linear-gradient(
      135deg,
      #ff4444 0%,
      #ff6b6b 100%);
  color: white;
  border: none;
  padding: 16px 36px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  width: fit-content;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 24px rgba(255, 68, 68, 0.35);
  letter-spacing: 0.3px;
}
.hero-btn:hover {
  background:
    linear-gradient(
      135deg,
      #e63939 0%,
      #ff4444 100%);
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(255, 68, 68, 0.45);
}
.hero-btn:active {
  transform: translateY(0);
}
.hero-image {
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(
      135deg,
      #f8fafc 0%,
      #e2e8f0 100%);
}
.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  transform: scale(1.02);
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
.blog-hero-banner:hover .hero-image img {
  transform: scale(1.08);
}
.blogs-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 24px;
  background: #f8f9fa;
}
.all-blog-cont {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 48px;
}
.section-header h2 {
  font-size: 36px;
  font-weight: 800;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -0.5px;
}
.see-all-link {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #007BA7;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}
.see-all-link:hover {
  gap: 14px;
  color: #005f87;
}
.see-all-link .arrow {
  font-size: 20px;
  transition: transform 0.3s ease;
}
.see-all-link:hover .arrow {
  transform: translateX(4px);
}
.blog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 32px;
}
.blog-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  height: 100%;
}
.blog-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
}
.blog-card-image {
  position: relative;
  width: 100%;
  height: 240px;
  overflow: hidden;
  background:
    linear-gradient(
      135deg,
      #f8fafc 0%,
      #e2e8f0 100%);
}
.blog-card-image img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.blog-card:hover .blog-card-image img {
  transform: scale(1.12);
}
.blog-category {
  position: absolute;
  top: 16px;
  left: 16px;
  background:
    linear-gradient(
      135deg,
      #ff4444 0%,
      #ff6b6b 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  box-shadow: 0 4px 12px rgba(255, 68, 68, 0.3);
}
.blog-card-content {
  padding: 28px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.blog-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}
.blog-date {
  display: flex;
  align-items: center;
  gap: 6px;
}
.blog-author {
  position: relative;
  padding-left: 16px;
}
.blog-author::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #6b7280;
}
.blog-card-title {
  font-size: 20px;
  font-weight: 800;
  line-height: 1.4;
  color: #1a1a1a;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  letter-spacing: -0.3px;
}
.blog-card-snippet {
  font-size: 15px;
  line-height: 1.7;
  color: #6b7280;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
}
.no-blogs {
  text-align: center;
  padding: 80px 20px;
  color: #6b7280;
  font-size: 18px;
  font-weight: 500;
}
@media (max-width: 1024px) {
  .blog-hero-banner {
    grid-template-columns: 1fr;
    margin: 60px 20px 40px;
  }
  .hero-content {
    padding: 60px 48px;
  }
  .hero-image {
    min-height: 320px;
    order: -1;
  }
  .hero-title {
    font-size: 42px;
  }
  .blog-grid {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 28px;
  }
  .blogs-main {
    padding: 48px 20px;
  }
}
@media (max-width: 768px) {
  .blog-hero-banner {
    max-width: 90%;
    margin-top: 100px;
  }
  .hero-content {
    padding: 40px 24px;
    text-align: left;
  }
  .hero-subtitle {
    font-size: 12px;
    letter-spacing: 2px;
  }
  .hero-title {
    font-size: 32px;
    margin-bottom: 16px;
  }
  .hero-description {
    font-size: 15px;
    margin-bottom: 28px;
    line-height: 1.6;
    max-width: 100%;
  }
  .hero-btn {
    padding: 14px 32px;
    font-size: 15px;
    width: 100%;
    max-width: 100%;
  }
  .hero-image {
    min-height: 280px;
  }
  .blogs-main {
    padding: 40px 16px;
  }
  .section-header {
    margin-bottom: 32px;
  }
  .section-header h2 {
    font-size: 28px;
  }
  .see-all-link {
    font-size: 15px;
  }
  .blog-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .blog-card {
    border-radius: 0px;
  }
  .blog-card-image {
    height: 220px;
    object-fit: fill;
  }
  .blog-card-content {
    padding: 24px;
  }
}
@media (max-width: 480px) {
  .blog-hero-banner {
    max-width: 90%;
    margin-top: 100px;
    border-radius: 0px;
  }
  .hero-content {
    max-width: 100%;
  }
  .hero-subtitle {
    font-size: 11px;
    letter-spacing: 1.5px;
    margin-bottom: 12px;
  }
  .hero-title {
    font-size: 26px;
    margin-bottom: 14px;
    line-height: 1.3;
  }
  .hero-description {
    font-size: 14px;
    margin-bottom: 24px;
    max-width: 100%;
  }
  .hero-btn {
    width: 100%;
    max-width: 100%;
    padding: 14px 24px;
    font-size: 14px;
  }
  .hero-image {
    min-height: 240px;
    object-fit: contain;
  }
  .blogs-main {
    padding: 32px 12px;
  }
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 28px;
  }
  .section-header h2 {
    font-size: 24px;
  }
  .see-all-link {
    font-size: 14px;
  }
  .blog-grid {
    gap: 20px;
  }
  .blog-card {
    border-radius: 0px;
  }
  .blog-card-image {
    height: 200px;
    object-fit: fill;
  }
  .blog-category {
    top: 12px;
    left: 12px;
    padding: 6px 12px;
    font-size: 11px;
  }
  .blog-card-content {
    padding: 20px;
  }
  .blog-meta {
    font-size: 12px;
    gap: 12px;
  }
  .blog-card-title {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .blog-card-snippet {
    font-size: 14px;
    line-height: 1.6;
  }
  .no-blogs {
    padding: 60px 16px;
    font-size: 16px;
  }
}
@media (max-width: 360px) {
  .blog-hero-banner {
    margin: 20px 8px 20px;
  }
  .hero-content {
    padding: 28px 16px;
  }
  .hero-title {
    font-size: 24px;
  }
  .hero-description {
    font-size: 13px;
  }
  .section-header h2 {
    font-size: 22px;
  }
  .blog-card-content {
    padding: 18px;
  }
  .blog-card-title {
    font-size: 17px;
  }
  .blog-card-snippet {
    font-size: 13px;
  }
}
/*# sourceMappingURL=blogs.component.css.map */
